import React from "react";

export default function CalloutBoxComponent({
  word,
  definition,
  imageSrc,
  imageAlt,
  imageWidth = 100,
  hasBorder = false,
}: {
  word?: string;
  definition: string;
  imageSrc?: string;
  imageAlt?: string;
  imageWidth?: number;
  hasBorder?: boolean;
}) {
  // Calculate base size once
  const baseSize = Math.max(2, Math.min(6, Math.floor(imageWidth / 20)));
  const imageSize = baseSize * 4;
  const blueBarSize = imageSize + 4;
  const padding = imageWidth <= 40 ? 2 : imageWidth <= 60 ? 3 : 4;

  const getWidthClass = (): string => `w-${imageSize} h-${imageSize}`;
  const getBlueBarWidth = (): string => `w-${blueBarSize}`;
  const getPaddingClass = (): string => `px-${padding}`;

  return (
    <div className="relative bg-gray-50 mx-4 p-4 rounded-md">
      {imageSrc && (
        <div
          className={`absolute left-0 top-0 bottom-0 bg-gray-200 rounded-l-md flex items-center justify-center py-2 ${getPaddingClass()} ${getBlueBarWidth()}`}
        >
          <img
            className={`${getWidthClass()} ${hasBorder ? "border-2 border-gray-100 rounded-md shadow-md shadow-gray-400" : ""}`}
            src={imageSrc}
            alt={imageAlt || ""}
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      )}
      {!imageSrc && (
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gray-200 rounded-l-md"></div>
      )}
      <div className="flex items-start relative z-10">
        {imageSrc && (
          <div className={`flex-shrink-0 ${getBlueBarWidth()}`}></div>
        )}
        <div className="flex-1 space-y-1 ml-4">
          {word && (
            <div className="border-b border-gray-300 pb-1 inline-block">
              <span className="font-semibold">{word}</span>
            </div>
          )}
          <div className="ql-editor prose prose-sm max-w-none -ml-4">
            {definition ? (
              <div dangerouslySetInnerHTML={{ __html: definition }} />
            ) : (
              <p className="text-gray-500 italic">
                Callout content will appear here...
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
